import { render, staticRenderFns } from "./POrderFilters.vue?vue&type=template&id=2132f72a"
import script from "./POrderFilters.vue?vue&type=script&lang=js"
export * from "./POrderFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports